import { useEffect, useState } from 'react';
import { getClientLogoUrl } from '../lib/clientLogo';
import { getCachedClientLogoUrl, setCachedClientLogoUrl } from '../lib/clientLogoCache';

export function useClientLogoUrl(logoPath?: string | null): string | null {
  const path = logoPath?.trim() ?? '';

  const [url, setUrl] = useState<string | null>(() =>
    path ? getCachedClientLogoUrl(path) : null,
  );

  useEffect(() => {
    if (!path) {
      setUrl(null);
      return;
    }

    const cached = getCachedClientLogoUrl(path);
    if (cached) {
      setUrl(cached);
      return;
    }

    let cancelled = false;

    void getClientLogoUrl(path).then((resolved) => {
      if (cancelled) return;
      if (resolved) setCachedClientLogoUrl(path, resolved);
      setUrl(resolved);
    });

    return () => {
      cancelled = true;
    };
  }, [path]);

  return url;
}
